



























































import { Component, Mixins } from 'vue-mixin-decorator';
// import { Component, Vue } from 'vue-property-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
import { Prop } from 'vue-property-decorator';
import { Enterprise } from '@/resources/enterprise/Enterprise';
import { PRICE_TYPES, Product } from '@/types/work/product';
import { ENTERPRISE_PRODUCTS_SHOW } from '@/router/work';
import { Getter } from 'vuex-class';
import { GET_CATEGORIES as GET_TYPE_CATEGORIES } from '@/store/models/pub/products/categories';
import { PublicCategories, PublicCategory } from '@/types/public/products/categories';
import { GET_CATEGORIES } from '@/store/models/work/enterprise/products/categories';
import { Categories, Category } from '@/types/work/product_category';
import { GET_ENTERPRISE } from '@/store/models/work/enterprises';
@Component
export default class ProductItem extends Mixins<SlotMixin>(SlotMixin) {
  @Prop() private product!: Product;
  @Prop() private price_type:number = PRICE_TYPES.price;
  public showRoute = ENTERPRISE_PRODUCTS_SHOW;

  @Getter(GET_TYPE_CATEGORIES) type_categories!: Array<PublicCategory>;
  @Getter(GET_CATEGORIES) categories!: Array<Category>;
  @Getter(GET_ENTERPRISE) enterprise!: Enterprise;

  protected PRICE_TYPES = PRICE_TYPES;

  public typeHierarchy (id:number|null):Array<any> {
    return (new PublicCategories(this.type_categories).getHierarchy(id));
  }

  public categoryHierarchy (id:number|null):Array<any> {
    return (new Categories(this.categories).getHierarchy(id));
  }
}
